import styled from "styled-components";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    InputPassword,
    InputText,
} from "../../components/form";

import {Button} from "../../components/ui/Button";
import { useEffect } from "react";
import { UPDATE_USER_PASSWORD } from "../../services/auth";
import { useMutation } from "@apollo/client";


const schema = yup.object({
    email: yup
      .string()
      .required("Ingresa un email valido")
      .email("Ingresa un email valido"),
    password: yup
      .string("Ingresa una contraseña valida")
      .min(6, "Ingresa una contraseña valida"),
    confirm: yup
      .string()
      .oneOf([yup.ref("password"), null], "Las contraseñas no coinciden")
      .required()
  });

export default function ChangePassword() {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ resolver: yupResolver(schema) });
    const [doUpdatePassword, resultsUpdatePassword] = useMutation(UPDATE_USER_PASSWORD);
    const onSubmit = (data) =>{ 
        const dataForSubmit = {
            email: data.email,
            password: data.password,
        };
        doUpdatePassword({ variables: dataForSubmit });
    };

    useEffect(() => {
      console.log(resultsUpdatePassword);
    }, [resultsUpdatePassword]);
    return (
        <Container>
            <StyledTitle>Cambiar contraseña</StyledTitle>
            <NewContractContainer onSubmit={handleSubmit(onSubmit)}>
                <TitleContract>Cambiar</TitleContract>
                <Divider />
                <FormContractContainer>
                    <RowContainer>
                        <InputText
                            label="Correo electrónico"
                            type="email"
                            placeholder="Correo electrónico"
                            register={{ ...register("email") }}
                            errorMessage={errors.email?.message}
                        />
                        <InputPassword
                            label="Ingresa una contraseña"
                            type="password"
                            placeholder="Contraseña"
                            register={{ ...register("password") }}
                            errorMessage={errors.password?.message}
                        />
                        <InputPassword
                            label="Confirma la contraseña"
                            type="password"
                            placeholder="Contraseña"
                            register={{ ...register("confirm") }}
                            errorMessage={errors.confirm?.message}
                        />
                    </RowContainer>
                </FormContractContainer>
                <Button text={"Proceder"} style={{ margin: "0 46px" }} type="submit" />
            </NewContractContainer>
        </Container>
    );
}

const Container = styled.div`
  width: 100vw;
  display: grid;
  justify-content: center;
`;

const StyledTitle = styled.h2`
  font-weight: 600;
  font-size: 40px;
  color: var(--header-text);
  margin: 100px 0 40px 0;
  @media only screen and (max-width: 768px) {
    font-size: 28px;
    max-width: 100vw;
    margin: 40px 0;
    text-align: center;
    padding: 10px;
  }
`;

const NewContractContainer = styled.form`
  width: 100%;
  border: 2px solid #eff0f6;
  border-radius: 20px;
  padding: 28px 0;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

const RowContainer = styled.div`
  display: flex;
  gap: 50px;
  & > div {
    width: 300px;
  }
`;

const TitleContract = styled.h3`
  font-weight: 600;
  font-size: 24px;
  color: var(--header-text);
  margin: 0 46px;
  @media only screen and (max-width: 640px) {
    margin: 0 16px;
  }
`;

const Divider = styled.div`
  height: 2px;
  width: 100%;
  background-color: #eff0f6;
`;

const FormContractContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 46px;
  transition: 200ms;
  gap: 20px;
`;
